import(/* webpackMode: "eager" */ "/vercel/path0/src/app/cart/page.js");
